import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CoacheeProfileNotesController } from 'presentation/page/profile/coachee-profile/coachee-profile-notes/coachee-profile-notes.controller';
import { IUserNote } from 'user/note/user-note';

@Component({
	selector: 'spr-coachee-profile-notes-note',
	templateUrl: './coachee-profile-notes-note.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'flex md:items-center p-3 md:space-x-3 even:bg-grey-alabaster md:flex-row flex-col md:space-y-0 space-y-3',
	},
})
export class CoacheeProfileNotesNoteComponent {
	@Input() note: IUserNote;
	constructor(public controller: CoacheeProfileNotesController) {}
}
